angular.module('SpidApp')

.constant('ChoixOptionAffranchissementDestinationAdapterConfig', {
  name : 'ChoixOptionAffranchissementDestination',
  fields : [
    {
    	local   : 'code',
    	distant : 'code'
    }, {
    	local   : 'type_option',
    	distant : 'type_option'
    }, {
    	local   : 'code_destination',
        distant : 'code_destination'
    }, {
        local   : 'code_affranchissement',
    	distant : 'code_affranchissement'
    }, {
    	local   : 'lib_long',
    	distant : 'lib_long'
    }, {
    	local   : 'is_default',
    	distant : 'is_default'
    }, {
    	local   : 'updated_at',
    	distant : 'updated_at'
    }
  ]
})
